import { Banner, Button } from '@cloudflare/kumo';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { BRAND_NAME, BRAND_LOGO } from '../lib/brand';
import { PasswordField } from '../components/ui/PasswordField';

const PASSWORD_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

/** Nova senha a partir do link enviado por e-mail (/redefinir-senha/:token) */
export function ResetPasswordPage() {
  const { token = '' } = useParams();
  const [senha, setSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!PASSWORD_RULE.test(senha)) return setError('A senha precisa de 8 caracteres ou mais, com letra maiúscula, minúscula e número');
    if (senha !== confirmacao) return setError('As senhas não conferem');
    setBusy(true);
    try {
      const res = await fetch('/api/auth/password/reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, senha }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'Não foi possível alterar a senha');
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível alterar a senha');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-brand">
          <img src={BRAND_LOGO} alt={BRAND_NAME} style={{ height: 28, width: 'auto' }} className="[[data-mode=dark]_&]:invert" />
        </div>
        {done ? (
          <div className="flex flex-col gap-5">
            <div>
              <h2 className="text-xl font-semibold auth-title">Senha alterada</h2>
              <div style={{ color: 'var(--text-muted)', marginTop: 6 }}>Entre com a nova senha.</div>
            </div>
            <Button variant="primary" onClick={() => window.location.assign('/login')}>Ir para o login</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col gap-5">
            <div>
              <h2 className="text-xl font-semibold auth-title">Criar nova senha</h2>
              <div style={{ color: 'var(--text-muted)', marginTop: 6 }}>O link vale por 1 hora e só pode ser usado uma vez.</div>
            </div>
            {error && <Banner variant="error" description={<>{error}</>} />}
            <PasswordField
              label="Nova senha"
              autoComplete="new-password"
              value={senha}
              onChange={setSenha}
            />
            <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>
              8 caracteres ou mais, com maiúscula, minúscula e número
            </div>
            <PasswordField label="Confirme a nova senha" autoComplete="new-password" value={confirmacao} onChange={setConfirmacao} />
            <Button type="submit" variant="primary" loading={busy}>Salvar senha</Button>
          </form>
        )}
      </div>
    </div>
  );
}
